import React, { useState, useEffect, useRef } from 'react';

function App() {
  const [email, setEmail] = useState('');
  const [bookName, setBookName] = useState('book.txt');
  const [bookContent, setBookContent] = useState('');
  const [currentPage, setCurrentPage] = useState(0);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const contentRef = useRef(null);
  
  // 🔴 ЗАМЕНИТЕ НА ВАШИ ДАННЫЕ:
  const API_URL = 'https://2dc526be.reader-39g.pages.dev/';
  const API_KEY = 'ваш_секретный_ключ';
  
  // Загрузка книги и прогресса
  useEffect(() => {
    const savedEmail = localStorage.getItem('reader-email');
    if (savedEmail) {
      setEmail(savedEmail);
      loadBookAndProgress(savedEmail);
    }
  }, []);
  
  const loadBookAndProgress = async (userEmail) => {
    setLoading(true);
    setError('');
    
    try {
      // Загрузка книги
      const bookRes = await fetch(
        `${API_URL}/api/book`,
        { headers: { 'X-API-Key': API_KEY } }
      );
      
      if (!bookRes.ok) {
        throw new Error(`Ошибка загрузки книги: ${bookRes.status}`);
      }
      
      const content = await bookRes.text();
      setBookContent(content);
      
      // Загрузка прогресса
      const progressRes = await fetch(
        `${API_URL}/api/progress?email=${userEmail}&book=${bookName}`,
        { headers: { 'X-API-Key': API_KEY } }
      );
      
      if (progressRes.ok) {
        const data = await progressRes.json();
        setCurrentPage(data.page || 0);
      }
    } catch (err) {
      setError(err.message);
      console.error('Ошибка загрузки:', err);
    } finally {
      setLoading(false);
    }
  };
  
  // Сохранение прогресса с задержкой
  const saveProgress = useRef(null);
  useEffect(() => {
    saveProgress.current = debounce(async (page) => {
      try {
        await fetch(`${API_URL}/api/progress`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-API-Key': API_KEY
          },
          body: JSON.stringify({ 
            email, 
            book: bookName, 
            page 
          })
        });
      } catch (err) {
        console.error('Ошибка сохранения:', err);
      }
    }, 2000);
  }, [email, bookName]);
  
  // Обработка скролла
  const handleScroll = () => {
    if (!contentRef.current) return;
    
    const container = contentRef.current;
    const scrollHeight = container.scrollHeight - container.clientHeight;
    const scrollPercentage = Math.floor((container.scrollTop / scrollHeight) * 100);
    
    if (scrollPercentage !== currentPage) {
      setCurrentPage(scrollPercentage);
      saveProgress.current(scrollPercentage);
    }
  };
  
  // Восстановление позиции
  useEffect(() => {
    if (contentRef.current && bookContent && currentPage > 0) {
      const container = contentRef.current;
      const scrollHeight = container.scrollHeight - container.clientHeight;
      container.scrollTop = (currentPage / 100) * scrollHeight;
    }
  }, [bookContent, currentPage]);

  const handleStartReading = () => {
    if (!email) {
      setError('Введите email');
      return;
    }
    localStorage.setItem('reader-email', email);
    loadBookAndProgress(email);
  };

  return (
    <div className="App">
      <header>
        <h1>Электронная читалка</h1>
      </header>
      
      <main>
        {error && <div className="error">{error}</div>}
        
        {!email ? (
          <div className="auth-box">
            <h2>Добро пожаловать</h2>
            <input
              type="email"
              placeholder="Ваш email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <button onClick={handleStartReading}>Начать чтение</button>
          </div>
        ) : loading ? (
          <div className="loading">Загрузка...</div>
        ) : (
          <div className="reader-container">
            <h2>{bookName}</h2>
            
            <div 
              ref={contentRef}
              className="book-content"
              onScroll={handleScroll}
              style={{ 
                height: '60vh', 
                overflowY: 'auto',
                padding: '15px',
                border: '1px solid #eee',
                borderRadius: '8px',
                marginBottom: '20px'
              }}
            >
              {bookContent.split('\n').map((line, i) => (
                <p key={i}>{line}</p>
              ))}
            </div>
            
            <div className="progress-container">
              <div className="progress-bar">
                <div 
                  className="progress-fill"
                  style={{ 
                    width: `${currentPage}%`,
                    height: '20px',
                    backgroundColor: '#4caf50',
                    borderRadius: '4px'
                  }}
                ></div>
              </div>
              <div className="progress-text">
                Прогресс: {currentPage}%
              </div>
            </div>
          </div>
        )}
      </main>
      
      <style>{`
        .App {
          max-width: 800px;
          margin: 0 auto;
          padding: 20px;
          font-family: Arial, sans-serif;
        }
        .auth-box {
          text-align: center;
          padding: 40px 20px;
          border: 1px solid #ddd;
          border-radius: 8px;
        }
        input {
          padding: 10px;
          margin: 10px 0;
          width: 80%;
          max-width: 300px;
        }
        button {
          padding: 10px 20px;
          background: #4caf50;
          color: white;
          border: none;
          border-radius: 4px;
          cursor: pointer;
        }
        .error {
          color: #f44336;
          padding: 10px;
          background: #ffebee;
          border-radius: 4px;
          margin-bottom: 20px;
        }
        .loading {
          text-align: center;
          padding: 40px;
        }
        .progress-container {
          margin-top: 20px;
        }
        .progress-bar {
          background: #f0f0f0;
          border-radius: 4px;
          overflow: hidden;
          margin-bottom: 5px;
        }
      `}</style>
    </div>
  );
}

// Вспомогательная функция для задержки
function debounce(func, wait) {
  let timeout;
  return function(...args) {
    clearTimeout(timeout);
    timeout = setTimeout(() => {
      func.apply(this, args);
    }, wait);
  };
}

export default App;